import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {post} from '../../fetch/fetchOptions';
import {PasswordPage} from './PasswordPage';
import axios from 'axios';
import {useErrorDisplay} from '../../common/useErrorDisplay';
import {LoadingSpinner} from '../../common/LoadingSpinner';
import {emailLoginUrl} from '../../fetch/urls';

export function Password({details, updateDispatcher}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useErrorDisplay(error);

  const submit = async ({email, password, rememberMe}) => {
    setLoading(true);
    setError(null);

    async function doPost() {
      try {
        const data = {
          email,
          password,
          rememberMe,
          queryString: details.queryString,
        };
        const res = await axios(
          post({
            url: emailLoginUrl(),
            data,
          }),
        );
        setLoading(false);
        updateDispatcher(res.data);
      } catch (exception) {
        console.log('Exception when submitting data: ', exception);
        setLoading(false);
        setError(exception);
      }
    }

    await doPost();
  };

  if (loading) {
    return <LoadingSpinner />;
  } else {
    return <PasswordPage submit={submit} details={details} />;
  }
}

Password.propTypes = {
  details: PropTypes.object.isRequired,
  updateDispatcher: PropTypes.func.isRequired,
};
